type FileDownloadType = 'csv' | 'neuro';

export const getFileDownloadUrl = (
  brokerId: number | undefined,
  clientId: number | undefined,
  key: string,
  type: FileDownloadType
): string | null => {
  if (brokerId == null || clientId == null || !key) {
    return null;
  }

  const extension = type === 'neuro' ? 'onnx' : 'csv';

  return `/files/ai/${brokerId}/${clientId}/${key}.${extension}`;
};

export const getFileDownloadName = (
  name: string,
  type: FileDownloadType
): string => {
  const extension = type === 'neuro' ? 'onnx' : 'csv';
  const baseName = name.replace(/\.(csv|onnx)$/i, '') || name;

  return `${baseName}.${extension}`;
};

type FetchFileByUrlOptions = {
  emptyOn404?: boolean;
};

export const fetchFileByUrl = async (
  url: string,
  options?: FetchFileByUrlOptions
): Promise<Blob> => {
  const response = await fetch(url, { credentials: 'same-origin' });

  if (options?.emptyOn404 && response.status === 404) {
    return new Blob([], { type: 'text/csv' });
  }

  if (!response.ok) {
    throw new Error(`Download failed: ${response.status}`);
  }

  return response.blob();
};

export const downloadFileByUrl = async (url: string, filename: string) => {
  const blob = await fetchFileByUrl(url);
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = filename;
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
};
